export interface ScopeEditorCustomRow {
  id: string;
  label: string;
  value: string;
}

export interface ScopeEditorPersistenceState {
  deletedRowIds: string[];
  customRows: ScopeEditorCustomRow[];
  pcfAttributeNames: Record<string, string>;
}

export type ScopeEditorPersistenceStateUpdater =
  | ScopeEditorPersistenceState
  | ((prevState: ScopeEditorPersistenceState) => ScopeEditorPersistenceState);

export const createScopeEditorPersistenceState = (
  pcfAttributeNames: Record<string, string>
): ScopeEditorPersistenceState => ({
  deletedRowIds: [],
  customRows: [],
  pcfAttributeNames,
});

export const resolveScopeEditorPersistenceState = (
  prevState: ScopeEditorPersistenceState,
  nextStateOrUpdater: ScopeEditorPersistenceStateUpdater
): ScopeEditorPersistenceState =>
  typeof nextStateOrUpdater === 'function'
    ? nextStateOrUpdater(prevState)
    : nextStateOrUpdater;
